import type { InvoiceCustomStyle } from "@components/invoice-customization/types/invoiceCustomStyle.types";

export type CompanyRole = {
  type: string;
  name: string;
};

/**
 * Es el membership UserCompany (relación) que trae:
 * - companyId
 * - company (objeto de compañía)
 * - userRole.role (rol del usuario en esa compañía)
 */
export type Company = {
  // id del membership (UsersCompany.id)
  id: number | string;

  // companyId real (Company.id)
  companyId: number | string;

  isDefault?: boolean;

  // Objeto compañía real
  company?: {
    id: number;
    businessName?: string;
    avatar?: string | null;
    logoUrl?: string | null;
    avatarUrl?: string | null;
    imageUrl?: string | null;
    logo?: string | null;
    businessEmail?: string | null;
    businessPhone?: string;
    dba?: string;
    ssn?: string;
    country?: string;
    state?: string;
    address?: string;
    zipCode?: string;
    coverageCountry?: string | null;
    coverageState?: string | null;
    coverageNationWide?: boolean | null;
    coverageAreas?: any[];
    minimumPaymentAmount?: number | string | null;
    invoiceCustomStyle?: InvoiceCustomStyle | null;
    invoiceNumberingMode?: "timestamped" | "sequential";
    invoiceNextNumber?: number | null;
  };

  // Rol del usuario dentro de esa compañía
  userRole?: {
    role?: CompanyRole;
  };
};

/**
 * - datos de `membership.company`
 * - con `role` inyectado desde `membership.userRole.role`
 */
export type CurrentCompany = {
  id: number;
  businessName?: string;
  avatar?: string | null;
  logoUrl?: string | null;
  avatarUrl?: string | null;
  imageUrl?: string | null;
  logo?: string | null;
  businessEmail?: string | null;
  businessPhone?: string;
  dba?: string;
  ssn?: string;
  country?: string;
  state?: string;
  address?: string;
  zipCode?: string;
  coverageCountry?: string | null;
  coverageState?: string | null;
  coverageNationWide?: boolean | null;
  coverageAreas: any[];
  role?: CompanyRole;
  timeZone?: string;
  minimumPaymentAmount?: number | string | null;
  invoiceCustomStyle?: InvoiceCustomStyle | null;
  invoiceNumberingMode?: "timestamped" | "sequential";
  invoiceNextNumber?: number | null;
} | null;

export type CoverageArea = {
  location: string | null;
  state: string | null;
  city: string | null;
  address: string | null;
  milesOfCoverage: number | null;
  latitude: number | null;
  longitude: number | null;
};

export type UserState = {
  uid: string;
  avatar: string | null;
  email: string;
  firstName: string;
  lastName: string;
  alias: string;
  birthDate: string;
  phoneNumber: string;
  country: string;
  countryCode?: string;

  // memberships
  companies: Company[];

  // Company.id actual
  activeCompanyId: number | string | null;

  // compañía actual (derivada del membership)
  company: CurrentCompany;

  residentialServices: any[];
  commercialServices: any[];

  workforces: any[];

  roles: any[];
  hasCoverageAreas: boolean;
};

export const initialUserState: UserState = {
  uid: "",
  avatar: null,
  email: "",
  firstName: "",
  lastName: "",
  alias: "",
  birthDate: "",
  phoneNumber: "",
  country: "",
  countryCode: "",
  companies: [],
  activeCompanyId: Number(sessionStorage.getItem("activeCompanyId")) ?? null,
  company: null,
  residentialServices: [],
  commercialServices: [],
  workforces: [],
  roles: [],
  hasCoverageAreas: false,
};
